import styled from 'styled-components';
import { hideScrollbar } from '@simplywallst/ui-core';

export const Wrapper = styled('section')`
  ${hideScrollbar}
`;

export const SidebarContainer = styled('div')`
  ${hideScrollbar}
`;
